import { ABOUT } from '../data/content'

export default function About() {
  return (
    <section className="about" id="about">
      <div className="container">
        <h2>{ABOUT.heading}</h2>
        <p className="about-body">{ABOUT.body}</p>
      </div>
    </section>
  )
}
